<template>
	<div>
		<div class="bread-line">
			<Breadcrumb>
				<Breadcrumb-item>基础管理</Breadcrumb-item>
				<Breadcrumb-item href="div">商品组管理</Breadcrumb-item>
				<Breadcrumb-item href="">查看</Breadcrumb-item>
			</Breadcrumb>
		</div>
		<div class="wms-split-lint wms-mt20">
			商品组详情
		</div>
		<IconBtnGroup :dataSource="btnGroup" @on-click="btnchange" class="wms-mt10"></IconBtnGroup>
		<AgGridVueCustom style="width: 100%;" class="ag-fresh wms-table wms-mt10"
						 :gridOptions="gridOptions"
						 :columnDefs="columnDefs"
						 :rowData="rowData"
						 :enableColResize="true"
						 rowSelection="multiple"
						 :suppressRowClickSelection="true"
						 :groupUseEntireRow="true"
						 :rowHeight="tableHeaderRowHeight"
						 :headerHeight="tableRowHeight"
						 domLayout="autoHeight"
						 :selectionChanged="selectChange"
						 :class="{'wms-no-data': rowData.length===0}"
						 suppressNoRowsOverlay
		>
		</AgGridVueCustom>
		<div class="wms-mt15 text-center">
			<Button type="ghost" small @click="back()">返回</Button>
		</div>

	</div>
</template>
<script>
    import {TableHeaderRowHeight, TableRowHeight, DefaultPageSize, DefaultPageSizeOpt} from 'utils/const'
    import {InterObj} from 'utils/serviceConst'
    import IconBtnGroup from 'components/common/iconBtnGroup/iconBtnGroup.vue'

    let moment = require('moment')
    moment().format()
    export default {
        name: 'goodsGroupDetail',
        data() {
            return {
                curTreeBreadData: [],
                ownerListData: [],
                mubanData: [],
                showGoodsCatTab: false,
                goodsGroupCode: '',
                groupName: '',
                owner: '',
                btnGroup: [
                    {
                        text: '新增商品编号',
                        icon: 'icon-Newly_added',
                        click: this.addGoods
                    }
                ],
                gridOptions: {},
                columnDefs: this.createColumnDefs(),
                rowData: [],
                curPage: 1,
                total: 0,
                tableHeaderRowHeight: TableHeaderRowHeight,
                tableRowHeight: TableRowHeight,
                DefaultPageSize: DefaultPageSize,
                DefaultPageSizeOpt: DefaultPageSizeOpt
            }
        },
        activated() {
            reSetAgTable(this.gridOptions.api, this.columnDefs)
        },
        beforeMount() {
            this.goodsGroupCode = this.$router.currentRoute.query.goodsGroupCode
            this.groupName = this.$router.currentRoute.query.groupName
            this.owner = this.$router.currentRoute.query.owner
        },
        mounted() {
            this.$Loading.start()
            this.gridOptions.api.sizeColumnsToFit()
            let queryGoodsList = this.queryGoodsList()
            Promise.all([queryGoodsList]).then(() => {
                this.$Loading.finish()
            })
        },
        components: {
            IconBtnGroup: IconBtnGroup
        },
        methods: {
            async queryGoodsList(para) {
                let self = this
                let res = await requestMethods.get(InterObj.queryGoodsList, {goodsGroupCode: self.goodsGroupCode})
                if (res.result === 'success') {
                    self.rowData = res.data
                    self.$Loading.finish()
                } else {
                    self.$Loading.error()
                    self.$Notice.warning({desc: res.msg})
                }
            },
            btnchange(params) {
                params.click()
            },
            addGoods() {
//                this.$router.push({name: 'goodsMgr'})
                window.location.href = '/basic-manage/goods/add?' + 'name=' + this.groupName + '&code=' + this.goodsGroupCode + '&owner=' + this.owner + ' '
            },
            back() {
                this.$router.push({name: 'goodsGroup'})
            },
            createColumnDefs() {
                return [
                    {
                        headerName: '',
                        field: 'selection',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        width: 60,
                        maxWidth: 60,
                        minWidth: 60
                    },
                    {
                        headerName: '序号',
                        field: 'index',
                        pinned: 'left',
                        minWidth: 60,
                        width: 60,
                        cellRenderer: function(params) {
                            let index = Number(params.rowIndex) + 1
                            return '<span>' + index + '</span>'
                        }
                    },
                    {
                        headerName: '货主名称',
                        field: 'owner',
                        width: 100
                    },
                    {
                        headerName: '商品条码',
                        field: 'barcode',
                        width: 100
                    },
                    {
                        headerName: '商品编号',
                        field: 'code',
                        width: 100
                    },
                    {
                        headerName: '商品名称',
                        field: 'name',
                        width: 150
                    },
                    {
                        headerName: '商品类别',
                        field: 'goodsCategoryName',
                        width: 100
                    },
                    {
                        headerName: '规格型号',
                        field: 'model',
                        width: 140
                    },
                    {
                        headerName: '单位',
                        field: 'unit',
                        width: 100
                    },
                    {
                        headerName: '颜色',
                        field: 'color',
                        width: 100
                    },
                    {
                        headerName: '保质期天数',
                        field: 'shelfLife',
                        width: 100
                    }
                ]
            },
            // 选中状态chanage事件
            selectChange() {
                this.selectArr = this.gridOptions.api.getSelectedRows()
                this.selectIds = _.map(this.selectArr, 'clientManageId')
                this.selectCode = _.map(this.selectArr, 'code')
            }
        },
        computed: {
            idsString() {
                return this.selectIds.join(',')
            },
            codeString() {
                return this.selectCode.join(',')
            }
        }
    }
</script>
<style lang="less" scoped>
	.bread-line {
		margin: 15px 0;
	}
	.setsize {
		font-size: 14px;
	}
</style>
